export default {
  CLIENT_ERROR: 'Sorry something went wrong, please try again.',
  SERVER_ERROR: 'Sorry something went wrong, please try again later.',
  TIMEOUT_ERROR: 'Request timed out.',
  CONNECTION_ERROR: 'Unable to reach our servers.',
  NETWORK_ERROR: 'Unable to reach our servers.',
  CANCEL_ERROR: ''
}



// WEBPACK FOOTER //
// ./src/Sagas/ApiErrorMessages.js